import React, { useState, useEffect } from 'react';
import Turnstile from 'react-turnstile';
import usePersonalData from '../../../hooks/usePersonalData';
import useDealershipsData from '../../../hooks/useDealershipsData';
import useLinksData from '../../../hooks/useLinksData';
import useLeadData from '../../../hooks/useLeadData';
import useConfiguratorData from '../../../hooks/useConfiguratorData';
import DealershipCustomDropDown from '../../../../utils/DealershipCustomDropDown';
import { isRutValid } from '../../../../utils';
import MaskedInput from 'react-text-mask';
import RutTextMask from 'rut-text-mask';
import Axios from 'axios';

const ModalPersonalDataBody = ({ onCloseModal, selectedModel, selectedVersion }) => {
    const { getPersonalData, setPersonalData } = usePersonalData();
    const { dealerships, getDealerships, selectedDealership, setSelectedDealership } = useDealershipsData();
    const { getLinks } = useLinksData();
    const { getPreselectedDealerId } = useConfiguratorData();

    const [ showSecondModal, setShowSecondModal ] = useState(false);
    const [ regions, setRegions ] = useState([]);
    const [ brands, setBrands ] = useState([]);
    const [ selectedRegion, setSelectedRegion ] = useState({});
    const [ selectedBrand, setSelectedBrand ] = useState({});
    const [ checkboxValue, setCheckboxValue ] = useState(false);
    const [ invalidEmail, setInvalidEmail ] = useState(false);
    const [ invalidPhoneNumber, setInvalidPhoneNumber ] = useState(false);
    const [ preselectedRegionValidated, setPreselectedRegionValidated ] = useState(false);
    const [ preselectedBrandValidated, setPreselectedBrandValidated ] = useState(false);
    const [ name, setName ] = useState({'first_name': '', 'last_name': ''});
    const [ turnstileToken, setTurnstileToken ] = useState(false);
    const [ localRut, setLocalRut ] = useState('');
    const [ isSubmitting, setIsSubmitting ] = useState(false);

    const preselectedDealerId = getPreselectedDealerId();
    const personalData = getPersonalData() || {};
    
    // Sincronizar RUT local con el contexto al montar
    useEffect(() => {
        if (personalData.rut && !localRut) {
            setLocalRut(personalData.rut);
        }
    }, []);
    const links = getLinks();
    const rexEmail = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    const rexPhoneNumber = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{2,6}$/;
    const isFormValid = name.first_name && name.last_name && personalData.phone_number && localRut && isRutValid(localRut) && checkboxValue && !invalidEmail && !invalidPhoneNumber && turnstileToken;

    const { createFirstStepLead, createLead } = useLeadData();

    const sitekey = document.getElementById("recaptcha_sitekey").getAttribute('value');

    useEffect(() => {
        getDealerships();
        Axios.get(`/api/dealerships/regions`)
        .then(response => {
            setRegions(response.data);
        })
        .catch((error) => {
            console.error(error);
        });
    }, []);


    useEffect(() => {
        /**
         * se filtra los dealers por region seleccionada
         * se filtra los dealers restantes por los que tengan asignada brand
         * se mapea el array para extraer las brands
         * ser ordenan las brands por nombre
         * Map usa la varita 🧙‍♂️ cuando le pasamos el id como key y el ojeto completo como value
         * y como no permite keys repetidos al llamar a values() solo tenemos las brands ordenadas sin repetir
         * ✨ M A G I A ✨
         */

        const filteredSortedBrands = dealerships.filter(dealer => dealer.region_id === selectedRegion.id)
        .filter(dealer => dealer.brand_id !== null)
        .map(dealer => ({id: dealer.brand_id, name: dealer.brand_name, rating: dealer.rating}));
        setBrands([...new Map(filteredSortedBrands.map(brand => [brand['id'], brand])).values()].sort((a, b) => (a.rating < b.rating) ? 1 : -1));
    }, [selectedRegion]);


    useEffect(() => {
        if(preselectedDealerId && dealerships.some(item => item.brand_id === preselectedDealerId)){
            let dealership = dealerships.find(item => item.brand_id === preselectedDealerId);
            let region = regions.find(region => region.id === dealership.region_id);
            setSelectedRegion(region ? region : {});
            setPreselectedRegionValidated(true)
        }
    }, [dealerships, regions, brands])

    useEffect(() => {
        if(preselectedDealerId && dealerships.some(item => item.brand_id === preselectedDealerId)){
            let dealership = dealerships.find(item => item.brand_id === preselectedDealerId);
            let brand = brands.find(brand => brand.id === dealership.brand_id);
            setSelectedBrand(brand ? brand : {});
            setPreselectedBrandValidated(true)
        }
    },[brands])

    // En salesforce necesitan nombre y apellido por separado
    useEffect(() => {
        if (name.first_name && name.last_name) {
            setPersonalData({
                full_name: `${name.first_name} ${name.last_name ? name.last_name : ''}`, 
                first_name: name.first_name, 
                last_name: name.last_name
            });
        }
    }, [name])

    const handleNameChange = (e) => {
        let trimmedValue = e.target.value;
        if (trimmedValue.length > 0 && trimmedValue[0] === ' ') {
            trimmedValue = trimmedValue.substring(1);
        }
        setName({ ...name, [e.target.name]: trimmedValue });
    }
    

    const handlePersonalDataInputChange = (e) => {
        if(e.target.name === 'email') validateEmail(e.target.value);
        if(e.target.name === 'phone_number') validatePhoneNumber(e.target.value);
        if(e.target.name === 'rut') {
            const rutValue = e.target.value;
            setLocalRut(rutValue);
            setPersonalData({rut: rutValue});
            return;
        }
        
        setPersonalData({[e.target.name]: e.target.value});
    }
    
    const handleRegionInputChange = (e) => {
        setSelectedRegion(e);
        setSelectedBrand({})
        setSelectedDealership({});
    }

    const handleBrandInputChange = (e) => {
        setSelectedBrand(e);
        setSelectedDealership({})
    }

    const handleDealershipInputChange = (e) => {
        setSelectedDealership(e);
    }

    const changeModal = () => {
        createFirstStepLead();
        setShowSecondModal(true);
    }

    const handleCheckboxChange = (e) => {
        setCheckboxValue(e.target.checked);
    }

    const validateEmail = (email) => {
        setInvalidEmail(!rexEmail.test(email));
    }

    const validatePhoneNumber = (phoneNumber) => {
        setInvalidPhoneNumber(!rexPhoneNumber.test(phoneNumber));
    }

    const finishLeadRegister = () => {
        if (isSubmitting) return;
        setIsSubmitting(true);
        createLead();
        onCloseModal();
    }

    const dealershipFilter = () => {
        if(preselectedBrandValidated){
            return dealerships.filter(item => item.brand_id === selectedBrand.id)
        }
        return dealerships.filter(item => item.region_id === selectedRegion.id && item.brand_id === selectedBrand.id)
    }

    const handleTokenSubmit = (token) => {
        fetch("/recaptcha/", {
            method: "POST",
            body: JSON.stringify({ token: token }),
            headers: {
                "Content-Type": "application/json",
                'X-CSRFToken': document.querySelector('meta[name ="csrf-token"]').content
            },
        })
        .then(response => response.json())
        .then((data) => {
            if (data.success){
                setTurnstileToken(true);
            }
        })
        .catch((error) => {
            console.log("ERROR", error);
        });
    }


    return (
        <>
            <div className="modal-box">
                <div className={ "modal-body step-one " + (!showSecondModal ? "" : " hide")}>
                    <section className="model-info">
                        <div className="title">
                            <h2>¡Comienza la cotización de tu {selectedModel.name}!</h2>
                        </div>
                        <p className="instruction">
                            Podrás seleccionar la versión, color, incoprorar mantenciones y accesorios. <strong>Además si lo deseas podrás simular tu cuota mensual y realizar una preaprobación de Financiamiento MAF en línea.</strong>
                        </p>
                        <img src={selectedModel.image ? selectedModel.image.url : null} alt={ selectedModel.image ? selectedModel.image.alt : null } />
                    </section>
                    <section>
                        <form id="personal-data-form" className="contact-form">
                            <div className="form-element">
                                <input 
                                    className="input" 
                                    type="text" 
                                    placeholder="Ingresa tu nombre" 
                                    value={name.first_name} 
                                    name="first_name" 
                                    autoComplete="off"
                                    onChange={(e) => handleNameChange(e)}>
                                </input>
                            </div>
                            <div className="form-element">
                                <input 
                                    className="input" 
                                    type="text" 
                                    placeholder="Ingresa tu apellido" 
                                    value={name.last_name} 
                                    name="last_name" 
                                    autoComplete="off"
                                    onChange={(e) => handleNameChange(e)}>
                                </input>
                            </div>
                            <div className="form-element">
                                <input  
                                    className={"input" + (invalidEmail ? " error" : "")} 
                                    type="text" 
                                    placeholder="Ingresa tu email" 
                                    value={personalData.email} 
                                    name="email" 
                                    autoComplete="off"
                                    onChange={(e) => handlePersonalDataInputChange(e)} required>
                                </input>
                            </div>
                            <div className="form-element">
                                <MaskedInput
                                    mask={RutTextMask}
                                    name="rut"
                                    placeholder="RUT"
                                    value={localRut}
                                    data-skip-imask="true"
                                    guide={false}
                                    keepCharPositions={false}
                                    autoComplete="off"
                                    className={localRut && localRut.length >= 8 && !isRutValid(localRut) ? 'error' : null}
                                    onChange={(e) => handlePersonalDataInputChange(e)} />
                            </div>
                            <div className="form-element">
                                <input 
                                    className={"input" + (invalidPhoneNumber ? " error" : "")} 
                                    type="text" 
                                    placeholder="Teléfono" 
                                    value={personalData.phone_number} 
                                    name="phone_number" 
                                    autoComplete="off"
                                    onChange={(e) => handlePersonalDataInputChange(e)}>
                                </input>
                            </div>
                            <div className="disclaimer privacy">
                                <label className="custom-checkbox">
                                    <input type="checkbox" checked={checkboxValue} onChange={(e) => handleCheckboxChange(e)} />
                                    <span className="checkmark"></span>
                                </label>
                                <span className="checkbox-tex" >He leído y acepto la <a href={links.tnc_page} target="_blank">política de privacidad</a> de mis datos personales.</span>
                            </div>
                            <Turnstile
                                theme="light"
                                sitekey={sitekey}
                                onVerify={(token) => {
                                    handleTokenSubmit(token);
                                }}
                            />
                        </form>
                    </section>
                    <section className="buttons">
                        <button className="btn black aceptar-cotizador" onClick={() => changeModal()} disabled={!isFormValid}>Aceptar</button>
                    </section>
                </div>
                <div className={ "modal-body step-two " + (!showSecondModal ? "hide" : "")}>
                    <div className="title">
                        <h2>Para mejorar tu experiencia y brindarte un mejor servicio sólo falta que elijas un concesionario</h2>
                    </div>
                    <section className="dropdowns-container">
                        <DealershipCustomDropDown 
                            selectedOption={preselectedBrandValidated ? {} : selectedRegion} 
                            label="Región" 
                            items={regions} 
                            isDisabled={preselectedRegionValidated}
                            onClickOption={(e) => handleRegionInputChange(e)}/> 
                        <DealershipCustomDropDown 
                            isDisabled={!selectedRegion?.id || preselectedBrandValidated}
                            selectedOption={selectedBrand} 
                            label="Concesionario" 
                            items={brands} 
                            onClickOption={(e) => handleBrandInputChange(e)}/> 
                        <DealershipCustomDropDown 
                            isDisabled={!selectedBrand?.id}
                            selectedOption={selectedDealership} 
                            label="Sucursal" 
                            items={dealershipFilter()} 
                            onClickOption={(e) => handleDealershipInputChange(e)}/> 
                    </section>
                    <section className="buttons">
                        <button className="btn black" onClick={() => finishLeadRegister()} disabled={!selectedDealership?.id || isSubmitting}>Comenzar</button>
                    </section>
                </div>
            </div>
        </>
    )
}

export default ModalPersonalDataBody;